import { Link } from '@tanstack/react-router';
import { Building2, Tag } from 'lucide-react';
import { Card, SectionHeader } from '@pixlide/ui';

/** Vue d'ensemble : porte d'entrée du back-office, deux raccourcis vers les deux espaces v1. */
export function OverviewPage() {
  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-6">
      <SectionHeader
        title="Back-office Pixlide"
        description="Gestion des comptes clients de la plateforme et du catalogue d'offres tarifaires."
      />

      <div className="grid gap-5 sm:grid-cols-2">
        <Link to="/tenants">
          <Card className="flex flex-col gap-3 p-6 transition hover:shadow-raised">
            <Building2 className="size-8 text-brand-500" strokeWidth={1.5} />
            <h2 className="text-lg font-semibold">Tenants</h2>
            <p className="text-sm text-ink-500">
              Liste des comptes clients, leur statut, et les actions de suspension, réactivation
              ou résiliation.
            </p>
          </Card>
        </Link>

        <Link to="/plans">
          <Card className="flex flex-col gap-3 p-6 transition hover:shadow-raised">
            <Tag className="size-8 text-brand-500" strokeWidth={1.5} />
            <h2 className="text-lg font-semibold">Offres</h2>
            <p className="text-sm text-ink-500">
              Catalogue des offres tarifaires : tarifs, capacités et activation.
            </p>
          </Card>
        </Link>
      </div>
    </div>
  );
}
